import {
  CompanyUsersComponent
} from './components/company/company-users/company-users.component';
import {
  AddBranchDialogComponent,
  AddUserDialogComponent,
  ConfirmCompanyAdminDialogComponent
} from './components/dialogs';
import {
  UsersComponent
} from './components/users/users.component';
import {
  AppUsersService,
  AppsService,
  AuthService,
  ChangeBranchesService,
  CompanyService,
  InvitationsService,
  MediaQueryService,
  ProfileApiService,
  TokenInterceptorService,
  UserAppsService,
  UsersSearchService,
  UsersService
} from 'app/services';
import {
  DragDropFileDirective,
  EmailExistsDirective,
  IfMobileDirective,
  IfTabletDirective,
  IsEmailDirective
} from 'app/directives';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule
} from '@angular/common/http';
import { MatPaginatorModule } from '@angular/material/paginator';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { AddRoleDialogComponent } from './components/apps/add-role-dialog/add-role-dialog.component';
import { AddUserToBranchDialogComponent } from './components/dialogs/add-user-to-branch-dialog/add-user-to-branch-dialog.component';
import { AppsComponent } from './components/apps/apps.component';
import { AppsDashboardComponent } from './components/apps/apps-dashboard/apps-dashboard.component';
import { AppsDetailsComponent } from './components/apps/apps-details/apps-details.component';
import { AppsDialogComponent } from './components/apps/apps-dialog/apps-dialog.component';
import { AppsInfoComponent } from './components/apps/apps-info/apps-info.component';
import { AppsPhotoComponent } from './components/apps/apps-photo/apps-photo.component';
import { AppsRolesComponent } from './components/apps/apps-roles/apps-roles.component';
import { AppsUsersComponent } from './components/apps/apps-users/apps-users.component';
import { AuthErrorComponent } from './components/auth-error/auth-error/auth-error.component';
import { BlockedUsersComponent } from './components/company/blocked-users/blocked-users.component';
import { BranchesTableComponent } from './components/branches/branches-table/branches-table.component';
import { CallbackComponent } from './components/callback/callback.component';
import { CommonModule } from '@angular/common';
import { CompanyBranchesComponent } from './components/company/company-branches/company-branches.component';
import { CompanyComponent } from './components/company/company.component';
import { CompanyDashboardComponent } from './components/company/company-dashboard/company-dashboard.component';
import { CompanyDetailComponent } from './components/company/company-detail/company-detail.component';
import { CompanyInfoComponent } from './components/company/company-info/company-info.component';
import { CompanyInvitesComponent } from './components/company/company-invites/company-invites.component';
// eslint-disable-next-line max-len
import { ConfirmDeleteBranchDialogComponent } from './components/dialogs/confirm-delete-branch-dialog/confirm-delete-branch-dialog.component';
import { ConfirmDeleteDialogComponent } from './components/dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { DeleteUserDialogComponent } from './components/dialogs/delete-user-dialog/delete-user-dialog.component';
import { ErrorComponent } from 'app/core/components/error/error.component';
import { GoToGroupsDialogComponent } from './components/auth-error/go-to-groups-dialog/go-to-groups-dialog.component';
import { InviteUserDialogComponent } from './components/dialogs/invite-user-dialog/invite-user-dialog.component';
import { InvitesComponent } from './components/invites/invites.component';
import { LayoutModule } from '@angular/cdk/layout';
import { LoginComponent } from './components/login/login.component';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { RecentCompanyComponent } from './components/company/recent-company/recent-company.component';
import { RecoverUserDialogComponent } from './components/users/user-recovery-dialog/user-recovery-dialog.component';
import { RemoveRoleDialogComponent } from './components/apps/remove-role-dialog/remove-role-dialog.component';
import { ResendInviteDialogComponent } from './components/dialogs/resend-invite-dialog/resend-invite-dialog.component';
import { SpinnerComponent } from 'app/core/components/spinner/spinner.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UserActivityComponent } from './components/users/user-activity/user-activity.component';
import { UserApplicationAccessComponent } from './components/users/user-application-access/user-application-access.component';
import { UserAppsDetailsComponent } from './components/apps/user-apps-details/user-apps-details.component';
import { UserBranchComponent } from './components/branches/user-branch/user-branch.component';
import { UserDetailComponent } from './components/users/user-detail/user-detail.component';
import { UserDialogComponent } from './components/users/user-dialog/user-dialog.component';
import { UserInfoComponent } from './components/users/user-info/user-info.component';
import { UserPhotoComponent } from './components/users/user-photo/user-photo.component';
import { environment } from '../../environments/environment';
import { MatStepperModule } from '@angular/material/stepper';
import { UnauthorizedDialogComponent } from './components/auth-error/unauthorized-dialog/unauthorized-dialog.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ClosedBranchDialogComponent } from './components/dialogs/closed-branch-dialog/closed-branch-dialog.component';
import { SupportTicketDialogComponent } from './components/dialogs/support-ticket-dialog/support-ticket-dialog.component';
import { SupportTicketFormDialogComponent } from './components/dialogs/support-ticket-form-dialog/support-ticket-form-dialog.component';
import { BranchAdminsComponent } from './components/branches/branch-admins/branch-admins.component';
import { ConfirmationDialogComponent } from './components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { UserSelectionDialogComponent } from './components/dialogs/user-selection-dialog/user-selection-dialog.component';
import { AppsSetupDialogComponent } from './components/apps/apps-setup-dialog/apps-setup-dialog.component';
import { CompanySubscriptionComponent } from './components/company/company-subscription/company-subscription.component';
import { ThirdPartyNoticesDialogComponent } from './components/dialogs/third-party-notices-dialog/third-party-notices-dialog.component';

const config = environment.alleAuthConfig;

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json?cacheBuster=' 
  + environment.cacheBusterHash);
}

@NgModule({
  declarations: [
    AddBranchDialogComponent,
    AddRoleDialogComponent,
    AddUserDialogComponent,
    RecoverUserDialogComponent,
    AddUserToBranchDialogComponent,
    AppsComponent,
    AppsDashboardComponent,
    AppsDetailsComponent,
    AppsDialogComponent,
    AppsInfoComponent,
    AppsRolesComponent,
    AppsPhotoComponent,
    AppsUsersComponent,
    AuthErrorComponent,
    BlockedUsersComponent,
    BranchesTableComponent,
    CallbackComponent,
    CompanyBranchesComponent,
    CompanyComponent,
    CompanyDashboardComponent,
    CompanyDetailComponent,
    CompanyInfoComponent,
    CompanyInvitesComponent,
    CompanyUsersComponent,
    CompanySubscriptionComponent,
    ConfirmCompanyAdminDialogComponent,
    ConfirmDeleteBranchDialogComponent,
    ConfirmDeleteBranchDialogComponent,
    ConfirmDeleteDialogComponent,
    DeleteUserDialogComponent,
    DragDropFileDirective,
    EmailExistsDirective,
    ErrorComponent,
    GoToGroupsDialogComponent,
    IfMobileDirective,
    IfTabletDirective,
    InviteUserDialogComponent,
    IsEmailDirective,
    LoginComponent,
    NotFoundComponent,
    RecentCompanyComponent,
    RemoveRoleDialogComponent,
    ResendInviteDialogComponent,
    SpinnerComponent,
    UserActivityComponent,
    UserApplicationAccessComponent,
    UserAppsDetailsComponent,
    UserBranchComponent,
    UserDetailComponent,
    UserDialogComponent,
    UserInfoComponent,
    UserPhotoComponent,
    UsersComponent,
    InvitesComponent,
    UnauthorizedDialogComponent,
    SnackbarComponent,
    ClosedBranchDialogComponent,
    SupportTicketDialogComponent,
    SupportTicketFormDialogComponent,
    BranchAdminsComponent,
    ConfirmationDialogComponent,
    UserSelectionDialogComponent,
    AppsSetupDialogComponent,
    ThirdPartyNoticesDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    LayoutModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    CommonModule,
    ErrorComponent,
    HttpClientModule,
    LayoutModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    SpinnerComponent,
    TranslateModule
  ],
  providers: [
    AppsService,
    AppUsersService,
    AuthService,
    ChangeBranchesService,
    CompanyService,
    InvitationsService,
    MediaQueryService,
    ProfileApiService,
    UserAppsService,
    UsersSearchService,
    UsersService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
  ]
})
export class AmCommonModule {}
